import { useEffect } from 'react';
import type { EChartsOption } from 'echarts';
import type { IEChartInstance } from '@/pages/intelligence/types/echart';

/**
 * echart配置项变化时,更新echart UI
 */
export default function useEChartRefreshWhenOptionsChange<T extends EChartsOption>(
  chartInstance: React.MutableRefObject<IEChartInstance | null>,
  option: T,
) {
  // echart配置项变化时,更新echart UI
  useEffect(() => {
    if (typeof chartInstance?.current?.setOption !== 'function') return;
    chartInstance?.current?.setOption(option, {
      /**
       * 是否不跟之前设置的 option 进行合并。默认为 false
       * 如果为 false，即表示合并
       * 如果为 true，表示所有组件都会被删除，然后根据新 option 创建所有新组件
       */
      notMerge: true,
      /**
       * 在设置完 option 后是否不立即更新图表，默认为 false
       * 如果为 false，即同步立即更新
       * 如果为 true，则会在下一个 animation frame 中，才更新图表
       */
      lazyUpdate: false,
      // 阻止调用 setOption 时抛出事件，默认为 false，即抛出事件。
      silent: false,
    });
  }, [option]);
}
